// Feed.js
import { connect } from 'react-redux';

import { FEED_CATEGORIES } from '../RemoteConfigKeys.js';

import getOperationData from '../selector/getOperationData.js';
import getModalData from '../selector/getModalData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import Feed from '../page/Feed.jsx';
import { breakpoint } from '../style/variables.js';
import { SEARCH_MODAL_ID } from '../resource/searchConstants.js';

const mapStateToProps = state => {
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const isSearchModalOpened = ['opening', 'display'].includes(
    getModalData(state, SEARCH_MODAL_ID, 'status')
  );
  const shouldRenderSearchBar =
    !isSearchModalOpened && deviceWidth && deviceWidth <= breakpoint.tablet;
  return {
    categories: getRemoteConfigData(state, FEED_CATEGORIES),
    shouldRenderSearchBar,
  };
};

export default connect(mapStateToProps)(Feed);
